import { BrowseViewResponseDto, ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import env from '@/env';
import { Standard } from '@/common';

export const getStandards = async ({
  page,
  pageSize,
  search,
  productId,
}: {
  page: number;
  pageSize: number;
  search: string;
  productId?: string;
}): Promise<BrowseViewResponseDto<Standard>> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/standards?${new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      search: search.toString(),
      productId: productId || '',
    })}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as BrowseViewResponseDto<Standard>;
  return response;
};
